const NEW_ACTIVITY_WINDOW_DAYS = 15;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const isNewActivity = (createdAt?: string | null) => {
  if (!createdAt) return false;

  const createdTime = new Date(createdAt).getTime();
  if (Number.isNaN(createdTime)) return false;

  const ageMs = Date.now() - createdTime;
  return ageMs >= 0 && ageMs <= NEW_ACTIVITY_WINDOW_DAYS * MS_PER_DAY;
};
